<template>
  <common-template>
    <div class="list">
      <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
      <div class="search inner">
        <div
          class="title accordion d-flex justify-content-between align-items-center"
          id="accordionDrawing-header"
          data-toggle="collapse"
          data-target=".accordionDrawing"
          aria-controls="searchContent searchButton"
        >
          <h2>{{ $t('検索条件') }}</h2>
          <div class="accordion-toggle-btn">
            <b-button block id="accordionDrawing-up">{{
              $t('閉じる')
            }}</b-button>
            <b-button block id="accordionDrawing-down">{{
              $t('開く')
            }}</b-button>
          </div>
        </div>
        <div
          id="searchContent"
          class="accordionDrawing content collapse"
          aria-labelledby="accordionDrawing-header"
        >
          <div class="d-flex flex-row">
            <div
              class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
            >
              <label for="search-status" class="label"
                >{{ $t('取引関係') }}:&nbsp;</label
              >
              <input
                v-model="params.isCustomer"
                type="checkbox"
                id="search-relation1"
                class="checkbox form-control"
              />
              <label class="label" for="search-relation1"
                >&nbsp;{{ $t('得意先') }}</label
              >
              <input
                v-model="params.isSupplier"
                type="checkbox"
                id="search-relation2"
                class="checkbox form-control"
              />
              <label class="label" for="search-relation2"
                >&nbsp;{{ $t('仕入先') }}</label
              >
            </div>
          </div>
          <div class="d-flex flex-row">
            <div
              class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
            >
              <label for="search-status" class="label"
                >{{ $t('取引先名') }}:&nbsp;</label
              >
              <input
                v-model="params.name_code"
                type="text"
                id="search-name"
                class="input -large--over form-control"
              />
            </div>
          </div>
          <div class="d-flex flex-row">
            <div
              class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
            >
              <label for="search-status" class="label"
                >{{ $t('締日種別') }}:&nbsp;</label
              >
              <input
                v-model="params.closingDayType"
                type="checkbox"
                id="search-closing1"
                class="checkbox form-control"
                value="date"
              />
              <label class="label" for="search-closing1"
                >&nbsp;{{ $t('日付') }}</label
              >
              <input
                v-model.number="params.closingDay"
                type="number"
                class="form-control input"
              />
              <input
                v-model="params.closingDayType"
                type="checkbox"
                id="search-closing2"
                class="checkbox form-control"
                value="eom"
              />
              <label class="label" for="search-closing2"
                >&nbsp;{{ $t('月末') }}</label
              >
              <input
                v-model="params.closingDayType"
                type="checkbox"
                id="search-closing3"
                class="checkbox form-control"
                value="each"
              />
              <label class="label" for="search-closing3"
                >&nbsp;{{ $t('都度払い') }}</label
              >
            </div>
          </div>
          <div class="d-flex flex-row">
            <div
              class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
            >
              <label for="search-status" class="label"
                >{{ $t('支払日種別') }}:&nbsp;</label
              >
              <input
                v-model="params.payType"
                type="checkbox"
                id="search-payDay1"
                class="checkbox form-control"
                value="dom"
              />
              <label class="label" for="search-payDay1"
                >&nbsp;{{ $t('当月日付') }}</label
              >
              <input
                v-model.number="params.payDay"
                type="number"
                class="form-control input"
              />
              <input
                v-model="params.payType"
                type="checkbox"
                id="search-payDay2"
                class="checkbox form-control"
                value="eom"
              />
              <label class="label" for="search-payDay2"
                >&nbsp;{{ $t('当月末') }}</label
              >
              <input
                v-model="params.payType"
                type="checkbox"
                id="search-payDay3"
                class="checkbox form-control"
                value="nmd"
              />
              <label class="label" for="search-payDay3"
                >&nbsp;{{ $t('翌月日付') }}</label
              >
              <input
                v-model="params.payType"
                type="number"
                class="form-control input"
              />
              <input
                v-model="params.payType"
                type="checkbox"
                id="search-payDay4"
                class="checkbox form-control"
                value="eonm"
              />
              <label class="label" for="search-payDay4"
                >&nbsp;{{ $t('翌月末') }}</label
              >
              <input
                v-model="params.payType"
                type="checkbox"
                id="search-payDay5"
                class="checkbox form-control"
                value="each"
              />
              <label class="label" for="search-payDay5"
                >&nbsp;{{ $t('都度払い') }}</label
              >
            </div>
          </div>
          <div class="d-flex flex-row">
            <div
              class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
            >
              <label for="search-status" class="label"
                >{{ $t('取引関係') }}:&nbsp;</label
              >
              <input
                v-model="params.payMethod"
                type="checkbox"
                id="search-payMethod1"
                class="checkbox form-control"
                value="cash"
              />
              <label class="label" for="search-payMethod1"
                >&nbsp;{{ $t('現金') }}</label
              >
              <input
                v-model="params.payMethod"
                type="checkbox"
                id="search-payMethod2"
                class="checkbox form-control"
                value="transfer"
              />
              <label class="label" for="search-payMethod2"
                >&nbsp;{{ $t('振込') }}</label
              >
              <input
                v-model="params.payMethod"
                type="checkbox"
                id="search-payMethod3"
                class="checkbox form-control"
                value="bill"
              />
              <label class="label" for="search-payMethod3"
                >&nbsp;{{ $t('手形') }}</label
              >
              <input
                v-model="params.payMethod"
                type="checkbox"
                id="search-payMethod4"
                class="checkbox form-control"
                value="check"
              />
              <label class="label" for="search-payMethod4"
                >&nbsp;{{ $t('小切手') }}</label
              >
            </div>
          </div>
        </div>
        <div id="searchButton" class="button accordionDrawing collapse">
          <button class="btn btn-info" @click="search(true)">
            {{ $t('検索') }}
          </button>
        </div>
      </div>
      <div class="inner d-flex mt-4 mb-4 w-100">
        <div class="d-flex col-6">
          <button
            @click="partnerModalOpen()"
            type="button"
            class="btn btn-success create-btn mr-3"
          >
            {{ $t('登録') }}
          </button>
          <button
            type="button"
            class="btn btn-success create-btn mr-3"
            @click="csvModalOpen('partners')"
            :disabled="isTrial"
          >
            {{ $t('取引先データ取込') }}
          </button>
        </div>
        <div class="d-flex col-6 justify-content-end">
          <select
            class="input input-sm display-number form-control custom-select"
            v-model="mixinParPage"
            @change="handleLimitChange()"
          >
            <option value="10">{{ $t('10行') }}</option>
            <option value="30">{{ $t('30行') }}</option>
            <option value="50">{{ $t('50行') }}</option>
            <option value="100">{{ $t('100行') }}</option>
          </select>
        </div>
      </div>
      <div class="table-list inner">
        <h2 class="title">{{ $t('検索結果') }}</h2>
        <div class="content">
          <table class="table table-bordered">
            <thead class="thead">
              <tr>
                <th scope="col" width="160">{{ $t('取引関係') }}</th>
                <th scope="col">{{ $t('取引先名') }}</th>
                <th width="30%" scope="col">{{ $t('管理番号') }}</th>
                <th width="100" scope="col"></th>
                <th width="100" scope="col" v-if="isUseEDI"></th>
                <th width="100" scope="col"></th>
              </tr>
            </thead>
            <tbody class="tbody">
              <template v-if="!load && this.list.length">
                <tr v-for="(item, index) in this.list" :key="index">
                  <td>
                    {{
                      item.isCustomer && item.isSupplier
                        ? $t('得意先・仕入先')
                        : ''
                    }}{{
                      item.isCustomer && !item.isSupplier ? $t('得意先') : ''
                    }}{{
                      !item.isCustomer && item.isSupplier ? $t('仕入先') : ''
                    }}
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn-light btn"
                      @click="detailLink(item)"
                    >
                      {{ $t('詳細') }}
                    </button>
                  </td>
                  <td v-if="isUseEDI">
                    <button
                      type="button"
                      class="btn"
                      :class="{
                        'btn-primary': item.isUseEDI,
                        'btn-light': !item.isUseEDI,
                      }"
                      @click="ediInvite(item)"
                      :disabled="!item.email || item.isUseEDI"
                    >
                      {{ $t(item.isUseEDI ? '連携中' : '連携') }}
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn-danger btn"
                      @click="deleteAlert(item)"
                    >
                      {{ $t('削除') }}
                    </button>
                  </td>
                </tr>
              </template>
              <template v-else-if="!load && !mixinGetItems.length">
                <tr>
                  <td rowspan="2" colspan="99" class="text-center">
                    {{ $t('ノーデータメッセージ') }}
                  </td>
                </tr>
              </template>
              <template v-else-if="load">
                <tr>
                  <td colspan="12">
                    <div class="d-flex justify-content-center m-5" v-if="load">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <paginate
        :page-count="mixinGetPageCount"
        :force-page="mixinGetForcePage"
        :page-range="3"
        :margin-pages="1"
        :click-handler="handlePageChange"
        :prev-text="'«'"
        :next-text="'»'"
        :container-class="'pagination justify-content-end'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
        :prev-class="'page-item'"
        :prev-link-class="'page-link'"
        :next-class="'page-item'"
        :next-link-class="'page-link'"
        ref="page"
      ></paginate>
      <partner-modal
        :kinds="processKinds"
        ref="partner"
        @registed="
          search()
          getProcessKindData()
        "
        @modalClose="
          search()
          getProcessKindData()
        "
      ></partner-modal>
      <csv-modal ref="csv"></csv-modal>
    </div>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '../../mixin/api'
import searchHelper from '../../mixin/search-helper'
import csvModal from './csvModal'
import partnerModal from './partnerModal'

export default {
  mixins: [searchHelper, Api],
  data() {
    return {
      list: [],
      params: {
        isCustomer: false,
        isSupplier: false,
        partnerGroupId: null,
        name: '',
        closingDayType: [],
        closingDay: null,
        payType: [],
        payDay: null,
        payMethod: [],
      },
      processKinds: [],
      load: false,
      pageTitle: '取引先情報一覧',
      company: {},
    }
  },
  components: {
    partnerModal,
    csvModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true
    try {
      await this.$store.dispatch('auth/user')
      const res = await this.$axios.get(
        `${this.$appConfig.CommonApiUrl}/company`,
        {
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
        },
      )
      this.company = res.data
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
    await this.search()
    await this.getProcessKindData()
  },
  methods: {
    // 工程区分を取得
    async getProcessKindData() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/process/kinds`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          },
        )
        this.processKinds = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async handleLimitChange() {
      await this.search(true)
    },
    async handlePageChange(pageNum) {
      this.mixinClickCallback(pageNum)
      this.search()
    },
    async search(resetPage = false) {
      try {
        this.load = true
        this.list = []
        if (resetPage === true) {
          this.mixinCurrentPageClear()
        }
        let params = {}
        for (let key of Object.keys(this.params)) {
          if (
            this.params[key] != null &&
            this.params[key] != undefined &&
            this.params[key] !== '' &&
            this.params[key] != false
          ) {
            if (
              key === 'closingDayType' ||
              key === 'payType' ||
              key === 'payMethod'
            ) {
              params[key] = this.params[key].toString()
            } else {
              params[key] = this.params[key]
            }
          }
        }
        this.list = await this.mixinGetPageList(
          `${this.$appConfig.CommonApiUrl}/partners`,
          params,
          {},
        )
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    // 取引先情報の編集のモーダルを開いたときの処理
    partnerModalOpen() {
      this.$refs.partner.modalOpen()
    },
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(`${item.name}`) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          // await this.$axios.put(
          await this.$axios.delete(`${this.$appConfig.CommonApiUrl}/partner`, {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: { id: item.id },
          })
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
          this.search()
          this.getProcessKindData()
        } catch (err) {
          this.$toasted.show(this.$t('データ削除エラーメッセージ'))
        }
      }
    },
    detailLink(item) {
      // console.log(this)
      let params = {}
      params.id = item.id
      window.location.href =
        process.env.NODE_ENV !== 'development'
          ? `/base/partner/detail.html?${this.mixinGetUrlParams(params)}`
          : `/partner/detail.html?${this.mixinGetUrlParams(params)}`
    },
    async ediInvite(item) {
      try {
        await this.$axios.post(
          `${this.$appConfig.CommonApiUrl}/edi_invites/`,
          { partnerId: item.id },
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          },
        )
        this.$toasted.success(`${this.$t('データ登録完了メッセージ')}`)
      } catch (error) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
    },
    // 製品データ取込のモーダルを開いたときの処理
    csvModalOpen(type) {
      this.$refs.csv.modalOpen(type)
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
    isTrial() {
      if (this.company) {
        if (this.company.hasOwnProperty('isTrial')) {
          return this.company.isTrial
        }
      }
      return false
    },
    isUseEDI() {
      return this.company && this.company.isUseEDI
    },
  },
}
</script>

<style lang="scss" scoped></style>
